import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "gostops_hr_token";

export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
};
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const apiError = (e, fallback = "Something went wrong") =>
  e?.response?.data?.detail || e?.message || fallback;

/** A generated file (xlsx) — fetched as a blob so the auth header goes with it, then handed to the
 *  browser under the filename the backend chose. */
export const downloadFile = async (path, params, body) => {
  const res = body
    ? await api.post(path, body, { params, responseType: "blob" })
    : await api.get(path, { params, responseType: "blob" });
  const match = /filename="?([^"]+)"?/.exec(res.headers["content-disposition"] || "");
  const name = res.headers["x-filename"] || (match && match[1]) || "download.xlsx";
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return name;
};
